var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        _vm._l(
          _vm.praticas.filter(function(pratica) {
            return pratica.ano
          }),
          function(pratica, index) {
            return _c(
              "el-collapse-item",
              {
                key: pratica.ano + "_" + index,
                attrs: { title: "Ano: " + pratica.ano }
              },
              [
                _c("div", [
                  _c("span", { staticClass: "title-praticas" }, [
                    _vm._v("Dados da prática")
                  ]),
                  _vm._v(" "),
                  _c("hr")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          attrs: { label: "Ano/Safra:", content: pratica.ano }
                        }),
                        _vm._v(" "),
                        _c("app-display", {
                          attrs: {
                            label:
                              "Previsão de colheita e produtividade (mês e ano/ sacas por hectare):",
                            content: _vm.formataPrevisoes(
                              pratica.previsoesColheitaProdutividade
                            ),
                            isContentInNextLine: true
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          attrs: {
                            label:
                              "Área destinada à plantio direto de grãos (em hectares):",
                            content: pratica.areaDestinada
                          }
                        }),
                        _vm._v(" "),
                        _c("app-display", {
                          attrs: {
                            label:
                              "Data de início da prática de plantio direto na área (mês e ano):",
                            content: _vm.formataDataInicio(pratica.dataInicio)
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("Bioinsumos", {
                  attrs: {
                    bioinsumo: {
                      utilizaBioinsumos: pratica.utilizaBioinsumos,
                      bioinsumos: pratica.bioinsumos
                    }
                  }
                }),
                _vm._v(" "),
                _c("Irrigacao", {
                  attrs: {
                    irrigacao: Object.assign(
                      {},
                      { possuiIrrigacao: pratica.possuiIrrigacao },
                      pratica.irrigacao
                    )
                  }
                }),
                _vm._v(" "),
                _c("Financiamento", {
                  attrs: {
                    financiamento: {
                      financiamentos: pratica.financiamentos,
                      outroFinanciamento: pratica.outroFinanciamento
                    }
                  }
                }),
                _vm._v(" "),
                _c("Descricao", { attrs: { descricao: pratica.descricao } })
              ],
              1
            )
          }
        ),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3df4971d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df4971d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/SPDG/SPDG.vue
// module id = null
// module chunks = 